import React, { useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  Input,
  Button,
} from "reactstrap";
import { getApiDataService, postApiDataService } from "../../../services/apiServices";
import { SETTING, UPDATE_SETTING } from "../../../services/CONSTANTS";
import { toast } from "react-toastify";
import Header from "components/Headers/Header";

function AdsPopup() {
  const [text, setText] = useState("");
  const [title, setTitle] = useState("");
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(false);

  // fetch current setting
  useEffect(() => {
    getApiDataService(SETTING).then((res) => {
      setText(res.data.ad_popup_text || "");
      setTitle(res.data.ad_popup_title || "");
      setEnabled(!!res.data.ad_popup_text);
    });
  }, []);

  const handleSave = () => {
    setLoading(true);
    postApiDataService(UPDATE_SETTING, {
      ad_popup_title: enabled ? title : null,
      ad_popup_text: enabled ? text : null,
    })
      .then(() => {
        toast.success("Ads Popup updated");
        setLoading(false);
      })
      .catch(() => {
        toast.error("Update failed");
        setLoading(false);
      });
  };

  return (
    <>
          <Header />
    <Container className="mt--7" fluid>
      <Row>
        <Col>
          <Card className="shadow">
            <CardHeader>
              <h3 className="mb-0">Ads Popup</h3>
            </CardHeader>
            <CardBody>
              <div className="form-check mb-3">
                <Input
                  type="checkbox"
                  id="ads-popup-enabled"
                  checked={enabled}
                  onChange={(e) => setEnabled(e.target.checked)}
                />{" "}
                <label className="mb-0" htmlFor="ads-popup-enabled">
                  Enable Popup
                </label>
              </div>
              <Input
                type="text"
                placeholder="Popup title for website"
                aria-label="Popup title for website"
                value={title}
                disabled={!enabled}
                onChange={(e) => setTitle(e.target.value)}
                className="mb-3"
              />

              <Input
                type="textarea"
                rows="5"
                placeholder="Popup text for website"
                aria-label="Popup text for website"
                value={text}
                disabled={!enabled}
                onChange={(e) => setText(e.target.value)}
              />

              <Button
                color="primary"
                className="mt-3"
                disabled={loading}
                onClick={handleSave}
              >
                Save
              </Button>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
    </>
  );
}

export default AdsPopup;
